// components/TopicForm.jsx
import React, { useState } from "react";
import { createTopic } from "../api/community";
import "../css/Form.css";

export default function TopicForm({ communityId, onSuccess }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [consoleError, setConsoleError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = { title, description, image };
      await createTopic(communityId, data);
      if (onSuccess) onSuccess();
      setTitle("");
      setDescription("");
      setImage(null);
    } catch (err) {
      setError("Failed to create topic.");
      setConsoleError("Topic creation error:", err.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <h2>Create Topic</h2>
      {error && <p className="form-error">{error}</p>}

      <label>Title</label>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />

      <label>Description</label>
      <textarea
        rows="3"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <label>Image</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImage(e.target.files[0])}
      />

      <button type="submit" disabled={loading}>
        {loading ? "Saving..." : "Create Topic"}
      </button>
    </form>
  );
}
